var i = /* @__PURE__ */ ((a) => (a.fill = "fill", a.outline = "outline", a))(i || {});
const n = (a, e) => {
  const t = (e.variant || a.variant) === "outline" ? "touch-area-outline" : "", l = e.disabled || a.disabled ? "touch-area-disabled" : "", r = e.error || a.error ? "touch-area-invalid" : "";
  return `touch-area ${t} ${l} ${r}`;
};
export {
  i as ERadioBorderVariants,
  n as getRadioBorderStyleClasses
};
